export default [
  {
    path: '/metaplanet_presale',
    name: 'PresaleView',
    component: () =>
      import(
        /* webpackChunkName: "portal-token" */ '@/views/PortalToken/PresaleView.vue'
      ),
    meta: { title: 'Presale', group: 'portal-token' },
  },
  {
    path: '/metaplanet_coinsale',
    name: 'CoinsaleView',
    component: () =>
      import(
        /* webpackChunkName: "portal-token" */ '@/views/PortalToken/CoinsaleView.vue'
      ),
    meta: { title: 'Coinsale', group: 'portal-token' },
  },
  {
    path: '/metaplanet_token',
    name: 'TokenView',
    component: () =>
      import(
        /* webpackChunkName: "portal-token" */ '@/views/PortalToken/TokenView.vue'
      ),
    meta: { title: 'Token', group: 'portal-token' },
  },
  {
    path: '/metaplanet_oldtoken',
    name: 'OldTokenView',
    component: () =>
      import(
        /* webpackChunkName: "portal-token" */ '@/views/PortalToken/OldTokenView.vue'
      ),
    meta: { title: 'Old Token', group: 'portal-token' },
  },
  {
    path: '/metaplanet_probit',
    name: 'ProbitView',
    component: () =>
      import(
        /* webpackChunkName: "portal-token" */ '@/views/PortalToken/ProbitView.vue'
      ),
    meta: { title: 'Probit', group: 'portal-token' },
  },
  {
    path: '/metaplanet_probit_deposit',
    name: 'ProbitDepositView',
    component: () =>
      import(
        /* webpackChunkName: "portal-token" */ '@/views/PortalToken/ProbitDepositView.vue'
      ),
    meta: { title: 'Probit Deposit', group: 'portal-token' },
  },
  {
    path: '/metaplanet_probit_order_history',
    name: 'ProbitOrderHistoryView',
    component: () =>
      import(
        /* webpackChunkName: "portal-token" */ '@/views/PortalToken/ProbitOrderHistoryView.vue'
      ),
    meta: { title: 'Probit Order History', group: 'portal-token' },
  },
  {
    path: '/metaplanet_lbank',
    name: 'LBankView',
    component: () =>
      import(
        /* webpackChunkName: "portal-token" */ '@/views/PortalToken/LBankView.vue'
      ),
    meta: { title: 'LBank', group: 'portal-token' },
  },
  {
    path: '/lbank_monitor',
    name: 'LBankMonitorView',
    component: () =>
      import(
        /* webpackChunkName: "portal-token" */ '@/views/PortalToken/LBankMonitorView.vue'
      ),
    meta: { title: 'LBank Monitor', group: 'portal-token' },
  },
  {
    path: '/metaplanet_lbank_order_history',
    name: 'LBankOrderHistoryView',
    component: () =>
      import(
        /* webpackChunkName: "portal-token" */ '@/views/PortalToken/LBankOrderHistoryView.vue'
      ),
    meta: { title: 'LBank Order History', group: 'portal-token' },
  },
  {
    path: '/lbank_trades',
    name: 'LBankTradesView',
    component: () =>
      import(
        /* webpackChunkName: "portal-token" */ '@/views/PortalToken/LBankTradesView.vue'
      ),
    meta: { title: 'LBank Trades', group: 'portal-token' },
  },
  {
    path: '/lbank_losses',
    name: 'LBankLossesView',
    component: () =>
      import(
        /* webpackChunkName: "portal-token" */ '@/views/PortalToken/LBankLossesView.vue'
      ),
    meta: { title: 'LBank Losses', group: 'portal-token' },
  },
  {
    path: '/lbank_trade_logs',
    name: 'LBankTradeLogsView',
    component: () =>
      import(
        /* webpackChunkName: "portal-token" */ '@/views/PortalToken/LBankTradeLogsView.vue'
      ),
    meta: { title: 'LBank Trade Logs', group: 'portal-token' },
  },
  {
    path: '/lbank_schedule',
    name: 'LBankScheduleView',
    component: () =>
      import(
        /* webpackChunkName: "portal-token" */ '@/views/PortalToken/LBankScheduleView.vue'
      ),
    meta: { title: 'LBank Schedule', group: 'portal-token' },
  },
  {
    path: '/lbank_asset_changes',
    name: 'LBankAssetChangesView',
    component: () =>
      import(
        /* webpackChunkName: "portal-token" */ '@/views/PortalToken/LBankAssetChangesView.vue'
      ),
    meta: { title: 'LBank Asset Changes', group: 'portal-token' },
  },
  {
    path: '/lbank_reports',
    name: 'ReportView',
    component: () =>
      import(
        /* webpackChunkName: "portal-token" */ '@/views/PortalToken/ReportView.vue'
      ),
    meta: { title: 'Reports', group: 'portal-token' },
  },
  {
    path: '/gas_analysis',
    name: 'GasAnalysisView',
    component: () =>
      import(
        /* webpackChunkName: "portal-token" */ '@/views/PortalToken/GasAnalysisView.vue'
      ),
    meta: { title: 'Gas Analysis', group: 'portal-token' },
  },
  {
    path: '/metaplanet_balance_probit_history',
    name: 'BalanceHistoryProbitView',
    component: () =>
      import(
        /* webpackChunkName: "portal-token" */ '@/views/PortalToken/BalanceHistoryProbitView.vue'
      ),
    meta: { title: 'Probit Balance History', group: 'portal-token' },
  },
  {
    path: '/trade_alert_settings',
    name: 'TradeAlertSettingsView',
    component: () =>
      import(
        /* webpackChunkName: "portal-token" */ '@/views/PortalToken/TradeAlertSettingsView.vue'
      ),
    meta: { title: 'Trade Alert Settings', group: 'portal-token' },
  },
]
